import { render, staticRenderFns } from "./PaperPage.vue?vue&type=template&id=77c71140&scoped=true"
import script from "./PaperPage.vue?vue&type=script&lang=js"
export * from "./PaperPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c71140",
  null
  
)

export default component.exports